import createApiClient from "./api";

const api = createApiClient();

export const fetchTasks = async (
  projectId,
  page = 1,
  pageSize = 10,
  filters,
  masterSearch = "",
  sortField = null,
  sortOrder = "asc",
) => {
  const token = localStorage.getItem("token");
  const response = await api.get(`/tasks`, {
    params: {
      project_id: projectId,
      skip: (page - 1) * pageSize,
      limit: pageSize,
      filters: JSON.stringify(filters),
      master_search: masterSearch,
      sort_field: sortField,
      sort_order: sortOrder,
    },
    headers: { Authorization: `Bearer ${token}` },
  });

  const { data, total } = response.data;
  const tasks = data.map((element) => ({
    ...element,
    formatted_ball_in_court_users:
      element?.ball_in_court_users
        ?.map((u) => {
          const name = u.username || `${u.first_name} ${u.last_name}`;
          return u.vendor_name ? `${name} (${u.vendor_name})` : name;
        })
        .join(", ") || "",
  }));

  return { tasks, total };
};

export const fetchTask = async (taskId) => {
  const token = localStorage.getItem("token");
  const response = await api.get(`/tasks/${taskId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const createTask = async (taskData, sendEmail = false) => {
  const token = localStorage.getItem("token");
  const response = await api.post("/tasks", taskData, {
    headers: { Authorization: `Bearer ${token}` },
    params: { email_notification: sendEmail },
  });
  return response.data;
};

export const updateTask = async (taskId, taskData, sendEmail = false) => {
  const token = localStorage.getItem("token");
  const response = await api.put(`/tasks/${taskId}`, taskData, {
    headers: { Authorization: `Bearer ${token}` },
    params: { email_notification: sendEmail },
  });
  return response.data;
};

export const deleteTask = async (taskId) => {
  const token = localStorage.getItem("token");
  const response = await api.delete(`/tasks/${taskId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const postTaskResponse = async (taskId, response) => {
  const token = localStorage.getItem("token");
  const payload = {
    response: response.response,
    attachments: response.attachments || [],
  };
  if (response.transfer_ball_to_task_manager !== undefined) {
    payload.transfer_ball_to_task_manager = response.transfer_ball_to_task_manager;
  }
  const result = await api.post(`/tasks/${taskId}/respond`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return result.data;
};

export const deleteTaskResponse = async (taskId, responseId) => {
  const token = localStorage.getItem("token");
  const response = await api.delete(`/tasks/${taskId}/responses/${responseId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const fetchNextTaskNumber = async (projectId) => {
  const token = localStorage.getItem("token");
  const response = await api.get(`/tasks/next-number?project_id=${projectId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const getTaskDefaultNotifyRecipients = async (taskId) => {
  const token = localStorage.getItem("token");
  const response = await api.get(`/tasks/${taskId}/default-notify-recipients`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data?.user_ids || [];
};

export const notifyProjectUsersAboutTask = async (taskId, userIds = null) => {
  const token = localStorage.getItem("token");
  const requestBody = {};
  if (userIds && Array.isArray(userIds) && userIds.length > 0) {
    requestBody.user_ids = userIds;
  }
  const response = await api.post(`/tasks/${taskId}/notify`, requestBody, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};
